import React from 'react';

const PageNotFound = () => {
    return (
        <div className="container text-center py-5">
            <p>404! Page Not Found!</p>
        </div>
    );
};

export default PageNotFound;